import { NgModule } from '@angular/core';
import { provideLazyLoad } from '@core/jss-utils';
import { ComponentTestingContainerComponent } from '@innogy/ab-testing';

@NgModule({
  imports: [
    provideLazyLoad({
      ComponentTesting: ComponentTestingContainerComponent,
    }),
  ],
})
export class ABTestingLazyModule {}
